import locales from '@swf/generated/locale-data.json';

import type { Category } from '../types/category';
import { SupportedLanguageList } from '../types/enums';

export const generateCategoryData = (categories: Category[]) =>
  categories
    .filter(({ visible }) => visible)
    .map(({ name, id }) => ({
      text: name,
      value: id
    }));

export const generateLanguageList = (siteLocales: string[]) =>
  Object.keys(SupportedLanguageList)
    .filter((key) => siteLocales.includes(SupportedLanguageList[key]))
    .map((key) => ({
      text: locales[SupportedLanguageList[key]].name,
      value: SupportedLanguageList[key]
    }));
